/**
 * Gets value from the map. If the resolved value is undefined, the defaultValue is returned in its place.
 */
import {Capability} from "./enums";
import {DATE_TIME_FORMAT, NOT_AVAILABLE} from "./constants";
import {getDocumentURL} from "./handler/ParentDataHandler";

export const getOrDefaultValueForCell = (map, key1, key2) => {
    if (map === undefined || map[key1] === undefined || (map[key1][key2] === undefined && key2)) {
        return "-";
    }
    return key2 ? map[key1][key2] : map[key1];
}

export const getTotalUnopenedBags = (nodeResourceDataMap, stowBinMetricsMap) => {
    var totalVal = 0;
    // eslint-disable-next-line no-unused-vars
    for (let [key, value] of nodeResourceDataMap) {
        totalVal  = totalVal + missingBagforStowV2(nodeResourceDataMap, stowBinMetricsMap, key);
    }
    return totalVal;
}

export const missingBagforStowV2 = (nodeResourceDataMap, stowBinMetricsMap, key1) => {
    const key2 = "binsMissingBag";
    let totalVal = nodeResourceDataMap.get(key1.toString())
    if (totalVal === undefined) {
        return 0;
    } else {
        if (stowBinMetricsMap !== undefined) {
            if (stowBinMetricsMap[key1] === undefined || (stowBinMetricsMap[key1][key2] === undefined && key2)) {
                return totalVal;
            } else {
                return Math.max(totalVal - stowBinMetricsMap[key1][key2], 0)
            }
        }
    }
}

export const getNodeResourceDataMap = (nodeResourceData) => {
    const nodeResourceDataMap = new Map(Object.entries(nodeResourceData));
    let nodeResourceMap = {};
    for (let [label, nodeResource] of nodeResourceDataMap) {
        nodeResourceMap[label] = nodeResource["numberOfSortZones"];
    }
    return  new Map(Object.entries(nodeResourceMap));
}

export const chainWalk = (func, defaultValue) => {
    try {
        const value = func()
        return (value === null || value === undefined) ? defaultValue : value;
    } catch (e) {
        return defaultValue
    }
}

export const getClusterForAisle = (aisle) => {
    return (aisle.split("-")[0]).replace(/\d/g, "");
}

export const getZoneForCartLocation = (cartLocation) => {
    return cartLocation.split('.')[0]
}

export const getNodeId = () => {
    const queryParams = new URLSearchParams(window.location.search);
    return queryParams.get('stationCode');
}

export const extractRouteCodePrefixesFromParam = (props) => {
    if (props.match && props.match.params && props.match.params.routeCodePrefixes)
        return props.match.params.routeCodePrefixes;
    return "";
}

export const getFormattedTimeFromEpoch = (millis) => {
    const dateTime = new Date(millis);
    const date = dateTime.getUTCDate();
    const month = getMonthName(dateTime.getUTCMonth());
    const year = dateTime.getUTCFullYear();
    const hours = makeNumberTwoDigit(dateTime.getUTCHours());
    const minutes = makeNumberTwoDigit(dateTime.getUTCMinutes());
    const seconds = makeNumberTwoDigit(dateTime.getUTCSeconds());

    return date + " " + month + " " + year + " " + hours + ":" + minutes + ":" + seconds;
}

export const getRelativeTimeFromEpoch = (time) => {
    const date = new Date();
    const currentTimeSeconds = Math.floor(date.getTime() / 1000);
    const delta = currentTimeSeconds - time/1000;

    if (delta > 2 * 24 * 3600) {
        return getFormattedTimeFromEpoch(delta * 1000);
    } else if (delta > 24 * 3600) {
        return "yesterday";
    } else if (delta > 3600) {
        return "a few hours ago";
    } else if (delta > 1800) {
        return "half an hour ago";
    } else if (delta > 60) {
        return Math.floor(delta / 60) + " minutes ago";
    }
}

export const getMonthName = (monthNumber) => {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June",
        "July", "Aug", "Sept", "Oct", "Nov", "Dec"
    ];
    return monthNames[monthNumber];
}

export const formQueryParams = (params) => {
    let queryParams = "";

    for (const key in params) {
        queryParams += (key + "=" + params[key] + "&");
    }
    return queryParams;
}

export const getAliasFromLoginId = (loginId) => {
    if (loginId.indexOf('@') !== -1) {
        return loginId.substr(0, loginId.indexOf('@'));
    }
    return loginId;
}

export const makeNumberTwoDigit = (number) => {
    return number < 10 ? '0' + number : number;
}

export const convertToString = (param) =>  {

    return param && param !== null ? param.toString() : ""
}

export const getFilteredLocations = (locations, packageMetricsMap, isDRSStowVisibilityEnabled) => {
    if (isDRSStowVisibilityEnabled) {
        return getFilteredLocationsForDRS(locations, packageMetricsMap);
    }
    return locations.filter(locationEle =>
        ( getOrDefaultValueForCell(packageMetricsMap, locationEle, "plannedPackages") !== '-'
            && getOrDefaultValueForCell(packageMetricsMap, locationEle, "plannedPackages") !== 0 )
        || locationEle.startsWith("OV")); // Because OV locations will always have 0 planned volume
}

export const getFilteredLocationsForDRS = (locations, packageMetricsMap) => {
    return locations.filter(locationEle =>
        ( getOrDefaultValueForCell(packageMetricsMap, locationEle, "plannedPackages") !== '-'
            && getOrDefaultValueForCell(packageMetricsMap, locationEle, "plannedPackages") !== 0 )
        || locationEle.startsWith("OV")
        || ( getOrDefaultValueForCell(packageMetricsMap, locationEle, "stowedPackages") !== '-'
            && getOrDefaultValueForCell(packageMetricsMap, locationEle, "stowedPackages") !== 0)
        || ( getOrDefaultValueForCell(packageMetricsMap, locationEle, "receivedPackages") !== '-'
            && getOrDefaultValueForCell(packageMetricsMap, locationEle, "receivedPackages") !== 0)
        || ( getOrDefaultValueForCell(packageMetricsMap, locationEle, "currentInductedPackages") !== '-'
            && getOrDefaultValueForCell(packageMetricsMap, locationEle, "currentInductedPackages") !== 0)
    );
}

export function getBaseUrl(endpoint) {
    const url = new URL(endpoint);
    return url.origin
}

export function getDateInMMDDYYYYWithOffset(offset){
    let presentDate = new Date();
    presentDate.setDate(presentDate.getDate()+offset)
    return (presentDate.getMonth() + 1) + "/" + presentDate.getDate() + "/" + presentDate.getFullYear();
}

export function getStowVsPlan(planned, stowed) {
    if (planned === 0) {
        return 0;
    }

    return ((stowed * 100.00) / planned).toFixed(2);
}

export function isAMPLStation(nodeId) {
    const nodeList = ["DQA5", "DQA6", "DGQ1", "DQL1", "DQV3", "DQV7", "DQV8", "DCT5", "DCT6", "DQB5", "DQB6", "DZG1", "DRQ1", "DAO9", "DAR9", "DAC8", "DAC9", "DLP9", "DWP3", "DFQ2", "DFQ3", "DFQ4", "DCQ2", "DCQ4", "DSQ3"];
    return nodeList.includes(nodeId);
}

export function isAMXLStation(nodeId) {
    return nodeId.startsWith("H") && nodeId !== "HMB1";
}

export function isCapabilityARorSSD(capability) {
    return Capability.SSD === capability || Capability.AR === capability;
}

export function isARStation(capability) {
    return Capability.AR === capability;
}

export function isOnlyRouteViewApplicable(nodeId, capability) {
    return isAMPLStation(nodeId) || isAMXLStation(nodeId) || isARStation(capability);
}

/**
 * Returns the current time in format [ MonthName dd, YYYY, HH:MM:SS GMT+__:__ ]
 * This pattern may slightly change according to current locale.
 * @param locale
 * @return string
 */
export const getCurrentFormattedTime = (locale) => {
    const currentDate = new Date();
    return new Intl.DateTimeFormat(locale, DATE_TIME_FORMAT).format(currentDate)
}

export const getSidelineRangeFilter = (reInductDay) => {
    let date = reInductDay.split("T")[0];
    const lessThanEqualDate = date+"T23:59:59"
    return {
        dimension: "SIDELINE_UNTIL_TIME",
        greaterThanEqual: reInductDay,
        lessThanEqual: lessThanEqualDate
    }
}

export const onRouteClick = (routeId, routeCode) => {
    const nodeId = getNodeId();
    getDocumentURL().then(result => {
        const params = [
            "Stow",
            routeId,
            NOT_AVAILABLE,
            NOT_AVAILABLE,
            NOT_AVAILABLE,
            NOT_AVAILABLE,
            routeCode,
            nodeId,
        ]
        const url = new URL(result.replace("stow", "pick"));
        const shareableLink = "/routeDetail/" + params.join("/");
        url.searchParams.set("shareableLink", shareableLink);
        window.open(url.href, "_parent")
    });
}

export const downloadCsvFromUrl = async (presignedUrl, filename = "sort_plan.csv") => {
    try {
        const fetchResponse = await fetch(presignedUrl, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Accept': 'text/csv,application/octet-stream'
            }
        });

        const blob = await fetchResponse.blob();
        const blobUrl = window.URL.createObjectURL(
            new Blob([blob], { type: 'text/csv;charset=utf-8;' })
        );

        const a = document.createElement("a");
        a.style.display = 'none';
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        // Release memory after download
        window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
        throw error;
    }
};



// WEBPACK FOOTER //
// ./src/Utility.js